import Link from 'next/link';

export default function Itinerary({ itinerary, noLinks, hideTitle }) {
  return (
    <>
      {!hideTitle && (
        <h3 className="tw-font-bold tw-pt-2 tw-inline-block tw-text-2xl tw-pr-1">
          {itinerary.title}{' '}
          <div className="tw-break-inside-avoid tw-inline-block">
            (
            {itinerary.duration % 7 === 0
              ? `${itinerary.duration / 7} week${
                  itinerary.duration === 7 ? '' : 's'
                }`
              : `${itinerary.duration} days`}
            )
          </div>
        </h3>
      )}
      {!hideTitle &&
      !noLinks &&
      itinerary.author &&
      itinerary.author.username !== 'itineraries' ? (
        <div className="tw-inline-block tw-text-sm">
          by{' '}
          <Link
            href={`/@${itinerary.author.username}`}
            className="tw-text-primary-200 hover:tw-underline"
          >
            {itinerary.author.username}
          </Link>
        </div>
      ) : (
        <></>
      )}
      <ol className="tw-list-none tw-pl-0 lg:tw-columns-2 tw-gap-x-12">
        {/* Guarded: an itinerary whose places have not loaded (or a generation
            that produced none) threw inside render and replaced the whole page
            with the generic error screen. */}
        {(itinerary.places || []).map((place, i) => {
          return (
            <li key={place.name} className="pt-1 tw-break-inside-avoid">
              <span className="tw-inline-flex tw-items-center tw-justify-center tw-h-6 tw-w-6 tw-rounded-full tw-border tw-bg-primary-500 tw-text-gray-200 tw-font-semibold">
                {i + 1}
              </span>{' '}
              <h5 className="tw-text-base	tw-inline-flex tw-font-semibold">
                {!noLinks && place.internalLink ? (
                  <Link
                    href={place.internalLink}
                    className="hover:tw-underline"
                  >
                    {place.name}
                  </Link>
                ) : (
                  place.name
                )}
              </h5>
              <p className="tw-text-sm">{place.description}</p>
            </li>
          );
        })}
      </ol>
    </>
  );
}
